import { PrincipalType } from '@entities/shared/account';

import { requirePrincipalType } from '../../require-principal-type';

// client-бакет: гейт на тип принципала (Client). Per-segment доступ додатково
// вирішується через requirePermission(Resource) всередині сегментів.
export const clientLoader = requirePrincipalType(PrincipalType.Client);
